export enum SearchType {
    PROGRAM = 'programme',
    CATCHUP = 'stcu',
    STCU = 'stcu',
    LONG_TIME_CATCHUP = 'ltcu',
    VOD = 'vod',
    SERIES = 'series',
    SEARSONS = 'season',
}

export enum Provider {
    HBOMAX = 'HBOMAX',
}

export type SearchOptions = {
    excludeProvider?: Provider;
    onlyplayable?: boolean;
    limit?: number;
};
